<template>
  <div class="guide-wrapper">
    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 주의사항</h3>
      <ul>
        <li
          v-for="serviceCaution in INDIVIDUAL_PURCHASE_NOTICE"
          :key="serviceCaution"
          v-html="getTextBreaks(getTextLinks(serviceCaution, linkObject))"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { isApp } from '@/common/util/common'
  import {
    CAUTIONS_FOR_SERVICE_LINK_APP,
    CAUTIONS_FOR_SERVICE_LINK_WEB,
    INDIVIDUAL_PURCHASE_NOTICE,
  } from '@/components/lnb/voucher/voucher-text/const'
  import { getTextLinks } from '@/common/util/string-manipulation/get-text-links'
  import { getTextBreaks } from '@/common/util/string-manipulation/get-text-breaks'

  const linkObject = computed(() =>
    isApp() ? CAUTIONS_FOR_SERVICE_LINK_APP : CAUTIONS_FOR_SERVICE_LINK_WEB,
  )
</script>

<style lang="scss" scoped>
  .guide-wrapper {
    margin-bottom: 120px;
  }
</style>
